import { render, staticRenderFns } from "./Vaccins.vue?vue&type=template&id=495d4afb&scoped=true&"
import script from "./Vaccins.vue?vue&type=script&lang=ts&"
export * from "./Vaccins.vue?vue&type=script&lang=ts&"
import style0 from "./Vaccins.vue?vue&type=style&index=0&id=495d4afb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "495d4afb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSubheader } from 'vuetify/lib/components/VSubheader';
installComponents(component, {VCard,VCardActions,VCol,VDivider,VRow,VSubheader})
